<template>
  <v-sheet class="mt-1 pa-3" tile>
    <v-card>
      <v-card-title>
        <span class="text-h5"
          >{{ $t('DOCUMENTS.DOCUMENTS_FOR_BUILDING') }} ({{ building.street }},
          {{ building.name }})
        </span>
      </v-card-title>

      <v-card-text>
        <v-data-table
          :headers="headers"
          :loading="!!!documents"
          :items="documents"
          :sort-by="'id'"
          :sort-desc="true"
        >
          <template v-slot:item.title="{ item }">
            <a target="_blank" :href="item.url" style="cursor: pointer;">{{
              item.title
            }}</a>
          </template>

          <template v-slot:item.action="{ item }">
            <div class="text-center">
              <v-btn color="error" :loading="loading" @click="remove(item.id)">
                <v-icon class="mr-1" small>mdi-delete</v-icon>
                {{ $t('BUTTON.REMOVE') }}
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-title>
        <span class="text-h5">{{
          $t('DOCUMENTS.ALL_AVAILABLE_DOCUMENTS')
        }}</span>
      </v-card-title>

      <v-card-text>
        <v-data-table
          :headers="headersAll"
          :loading="!!!documentsAll"
          :items="documentsAll"
          :sort-by="'id'"
          :sort-desc="true"
        >
          <template v-slot:item.title="{ item }">
            <a target="_blank" :href="item.url" style="cursor: pointer;">{{
              item.title
            }}</a>
          </template>

          <template v-slot:item.action="{ item }">
            <div class="text-center">
              <v-btn color="success" :loading="loading" @click="add(item.id)">
                <v-icon class="mr-1" small>mdi-plus</v-icon>
                {{ $t('BUTTON.ADD') }}
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-card-text>

      <v-btn outlined text @click="$emit('close')">
        {{ $t('BUTTON.CLOSE') }}
      </v-btn>
    </v-card>
  </v-sheet>
</template>

<script>
export default {
  props: {
    building: {
      type: Object,
      required: true
    },
    documentsAfterUpdate: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    documents: [],
    documentsAll: []
  }),

  computed: {
    loading() {
      return this.$store.getters['loading'];
    },

    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('ITEM.TITLE'),
          value: 'title'
        },
        {
          text: this.$t('ITEM.TYPE'),
          value: 'type'
        },
        { text: '', value: 'action', align: 'center' }
      ];
    },

    headersAll() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('ITEM.TITLE'),
          value: 'title'
        },
        {
          text: this.$t('ITEM.TYPE'),
          value: 'type'
        },
        { text: '', value: 'action', align: 'center' }
      ];
    }
  },

  created() {
    this.documents = this.documentsAfterUpdate;
    // this.documentsAll = this.$store.state.document.documents.data
    this.$store.dispatch('document/retrieveDocuments').then(({ data }) => {
      this.documentsAll = data.data;
    });
  },

  methods: {
    add(id) {
      this.$store.commit('loading', true);
      this.$store
        .dispatch('document/addDocumentForBuilding', {
          document_id: id,
          building_id: this.building.id
        })
        .then(() => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.refreshDocuments();
          this.$store.commit('loading', false);
        })
        .catch(() => {
          this.$store.commit('loading', false);
        });
    },

    remove(id) {
      this.$store.commit('loading', true);
      this.$store
        .dispatch('document/removeDocumentForBuilding', {
          document_id: id,
          building_id: this.building.id
        })
        .then(() => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.refreshDocuments();
          this.$store.commit('loading', false);
        })
        .catch(() => {
          this.$store.commit('loading', false);
        });
    },

    refreshDocuments() {
      this.$store
        .dispatch('document/retrieveDocumentsForBuilding', this.building.id)
        .then(({ data }) => {
          this.documents = data.data;
        });
    }
  }
};
</script>
